
import { ChildCard } from "@/components/children/ChildCard";
import { ChildrenEmptyState } from "@/components/children/ChildrenEmptyState";
import { Database } from "@/types/supabase";

type Child = Database["public"]["Tables"]["children"]["Row"];

interface ChildrenListProps {
  children: Child[];
  onEdit: (child: Child) => void;
  onDelete: (childId: string) => void;
  onAddChild: () => void;
}

export function ChildrenList({ children, onEdit, onDelete, onAddChild }: ChildrenListProps) {
  if (children.length === 0) {
    return <ChildrenEmptyState onAddChild={onAddChild} />;
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {children.map((child) => (
        <ChildCard
          key={child.id}
          child={child}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
